import { useQuery } from "@tanstack/react-query";

/** Versie van deze build, bv. `26.11.259` (jaar.maand.PR); lokaal `dev`. Zie apps/web/build/appVersion.ts. */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? "dev";
/** Volledige commitcode van deze build (leeg buiten Render). */
export const APP_COMMIT: string = import.meta.env.VITE_APP_COMMIT ?? "";

/** Versie met korte commit, als context bij een supportbericht (max. 50 tekens). */
export function appVersionLabel() {
  return APP_COMMIT ? `${APP_VERSION} (${APP_COMMIT.slice(0, 7)})` : APP_VERSION;
}

/** Commit die nu live staat volgens de server (`/version.json` uit dezelfde build); null als onbekend. */
async function liveCommit(): Promise<string | null> {
  const res = await fetch("/version.json", { cache: "no-store", credentials: "same-origin" });
  if (!res.ok) return null;
  const body = (await res.json()) as { commit?: unknown };
  return typeof body.commit === "string" && body.commit ? body.commit : null;
}

/** True als er een nieuwere versie live staat dan deze (vastgehouden) app; alleen gevraagd als `enabled`. */
export function useNewVersionAvailable(enabled: boolean) {
  const q = useQuery({
    queryKey: ["app-version"],
    queryFn: liveCommit,
    enabled: enabled && !!APP_COMMIT && navigator.onLine,
    staleTime: 60_000,
    retry: false,
  });
  return !!APP_COMMIT && !!q.data && q.data !== APP_COMMIT;
}

/** Nieuwe service worker ophalen (die neemt meteen over) en daarna herladen. */
export async function reloadToNewVersion() {
  try {
    const reg = await navigator.serviceWorker?.getRegistration();
    if (reg) {
      const changed = new Promise<void>((resolve) =>
        navigator.serviceWorker.addEventListener("controllerchange", () => resolve(), { once: true }),
      );
      await reg.update();
      await Promise.race([changed, new Promise((r) => setTimeout(r, 4000))]);
    }
  } finally {
    location.reload();
  }
}
